/*
  Silph TCG — menu principal : le titre mène à sa page, la flèche ouvre le sous-menu.

  Le titre est un <a> placé dans le <summary> d'un <details>. Or l'activation d'un <summary>
  déplie le <details> : sans rien faire, cliquer sur le titre ouvrirait le méga-menu AU LIEU de
  naviguer. On arrête donc l'événement sur le lien pour qu'il n'atteigne jamais le <summary>.
  La flèche, elle, laisse passer le clic : c'est elle qui ouvre et ferme le sous-menu.
*/
(function () {
  // Deux menus utilisent ce partage : la barre horizontale sur ordinateur, et le tiroir sur mobile.
  var SELECTEURS = '.header__inline-menu summary .header__menu-link, .menu-drawer summary .menu-drawer__menu-link';

  function bind(root) {
    (root || document).querySelectorAll(SELECTEURS).forEach(function (link) {
      if (link.dataset.silphSplit === 'true') return;
      link.dataset.silphSplit = 'true';

      link.addEventListener('click', function (event) {
        // Laisser le navigateur suivre le lien, mais empêcher le <details> de s'ouvrir.
        event.stopPropagation();
      });

      // Au clavier, Entrée sur le lien doit naviguer (et non déplier le sous-menu).
      link.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') event.stopPropagation();
      });
    });
  }

  function start() {
    bind(document);
    // Le header est re-rendu par l'éditeur de thème : on re-branche après chaque chargement de section.
    document.addEventListener('shopify:section:load', function (event) {
      bind(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
